import { Box } from "@mui/material";
import Lottie from "lottie-react";
import LOTTIE_IMAGE from "../services/404_lottie.json";
import Constant from "../services/Constant";

const NotFound = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: Constant.COLOR_PALLETE.background.gd,

      }}
    >
      <Lottie
        animationData={LOTTIE_IMAGE}
        loop
        autoplay
        style={{
          width: "100%",
          maxWidth: 1000,
          height: "auto",
        }}
      />
    </Box>
  );
};

export default NotFound;
